import React from 'react';

import { useTranslation } from 'react-i18next';

import OnboardingSidebarBg from '@/assets/images/onboarding-sidebar-background.png';
import LogoLight from '@/assets/svgs/logo-light.svg';

export const UnauthenticatedSidebar: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <div
      className="hidden w-full max-w-sm flex-col justify-between border-r border-white/10 bg-zinc-900 bg-cover bg-center p-10 dark:border-white/10 md:flex"
      style={{ backgroundImage: `url(${OnboardingSidebarBg})` }}
    >
      <div className="flex items-center gap-2">
        <img alt={t('contentDescription.productLogo')} src={LogoLight} className="size-8" />
        <span className="text-xl font-semibold text-sidebar-foreground">{t('productName')}</span>
      </div>
      <div className="flex flex-col">
        <div className="text-lg/6 font-semibold text-sidebar-foreground">{t('sampleFeedback')}</div>
        <div className="mt-3 text-sm/5 font-normal text-sidebar-ring">
          {t('sampleFeedbackAuthor')}
        </div>
      </div>
    </div>
  );
};
